import angular from 'angular';
import { ssDialogService } from 'app/services';
import { actionIcon } from 'app/components/global';
import controller from './select-department-team-members-dialog.controller';
import template from './select-department-team-members-dialog.html';


class dialogService {
  getOptions($event, { department = null, customerId = 0 }) {
    return {
      controller,
      controllerAs: 'selectDepartmentTeamMembersDialogVM',
      locals: {
        customerId,
        department,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.selectTeamMembersDialog', [
  ssDialogService,
  actionIcon
])
  .service('selectTeamMembersDialog', dialogService)
  .name;

console.log('app.components.advisory.enterpriseModeling.editDepartmentDialog created');
